class ProductCardMetaOverflow {
  constructor(meta) {
    this.meta = meta;
    this.productType = meta.querySelector('[data-product-card-meta-type]');
    this.separator = meta.querySelector('[data-product-card-meta-separator]');
    this.fabric = meta.querySelector('[data-product-card-meta-fabric]');
    this.frame = null;

    if (!this.productType || !this.separator || !this.fabric) {
      return;
    }

    this.resizeObserver = new ResizeObserver(() => this.scheduleLayout());
    this.resizeObserver.observe(meta);
    this.scheduleLayout();
  }

  scheduleLayout() {
    cancelAnimationFrame(this.frame);
    this.frame = requestAnimationFrame(() => this.layout());
  }

  layout() {
    this.meta.removeAttribute('data-material-only');

    const availableWidth = this.meta.clientWidth;

    if (availableWidth <= 0) {
      return;
    }

    const styles = getComputedStyle(this.meta);
    const gap = Number.parseFloat(styles.columnGap || styles.gap) || 0;
    const requiredWidth = this.productType.scrollWidth + this.separator.offsetWidth + this.fabric.scrollWidth + gap * 2;

    this.meta.toggleAttribute('data-material-only', requiredWidth > availableWidth + 0.5);
  }
}

const initializedMetaRows = new WeakSet();

function initializeMetaRows(root = document) {
  const rows = root.matches?.('[data-product-card-meta]')
    ? [root]
    : root.querySelectorAll?.('[data-product-card-meta]') || [];

  rows.forEach((row) => {
    if (!initializedMetaRows.has(row)) {
      initializedMetaRows.add(row);
      new ProductCardMetaOverflow(row);
    }
  });
}

initializeMetaRows();

new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    mutation.addedNodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE) {
        initializeMetaRows(node);
      }
    });
  });
}).observe(document.documentElement, { childList: true, subtree: true });
